var _g, _g2, _circle, _g3, _g4, _g5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacyPolicyNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 337,
    viewBox: "0 0 441 337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3905_13064)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.438,
    y: 135.012,
    width: 52.6721,
    height: 46.6029,
    rx: 4.33515,
    fill: "#53CD60"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3905_13064)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 206.772,
    cy: 158.527,
    r: 89.5995,
    stroke: "#5CDF6A",
    strokeOpacity: 0.1,
    strokeWidth: 49.3602,
    strokeLinecap: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 206.77,
    cy: 158.527,
    r: 135.414,
    stroke: "#97A9C0",
    strokeWidth: 14.7448,
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3905_13064)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 207.567,
    cy: 158.542,
    r: 106.488,
    stroke: "#53CD60",
    strokeOpacity: 0.45,
    strokeWidth: 1.53926,
    strokeLinecap: "round",
    strokeDasharray: "14.81 14.81",
    shapeRendering: "crispEdges"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3905_13064)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 206.681,
    cy: 153.85,
    r: 79.4579,
    fill: "#357453"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3905_13064)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.148,
    y: 142.266,
    width: 74.5686,
    height: 67.3754,
    rx: 17.8629,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.973 142.807V126.293C188.973 117.173 196.366 109.779 205.487 109.779V109.779C214.607 109.779 222.001 117.173 222.001 126.293V142.807",
    stroke: "#53CD60",
    strokeWidth: 13.547
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.498 190.389L201.153 187.497L199.674 182.38C198.841 179.5 199.625 176.394 201.724 174.254L202.18 173.789C204.961 170.954 209.455 170.735 212.498 173.287C214.933 175.33 215.842 178.672 214.776 181.666L212.7 187.497L209.873 190.389V204.851H203.498V190.389Z",
    fill: "#5F5E5E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285.399 55.9035C284.963 54.7944 285.722 53.5798 286.91 53.484L376.143 46.2872C379.225 46.0386 382.113 47.8115 383.288 50.6718L406.851 108.078C407.864 110.548 406.158 113.285 403.494 113.462L310.398 119.635L285.399 55.9035Z",
    fill: "#082D59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288.692 56.9727L379.623 50.9713L402.574 107.963L311.004 114.29L288.692 56.9727Z",
    fill: "#53CD60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M312.971 123.262L395.7 117.353L384.627 142.796L300.823 149.649L312.971 123.262Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M285.569 178.076C283.038 178.247 281.325 175.546 282.558 173.33L311.236 121.803C311.747 120.885 312.678 120.276 313.725 120.175L405.867 111.34C408.306 111.106 410.092 113.591 409.092 115.828L385.05 169.619C384.568 170.699 383.528 171.425 382.348 171.505L285.569 178.076Z",
    fill: "#1C59A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M282.718 174.703L311.078 118.74L405.776 112.437L381.795 167.574L282.718 174.703Z",
    fill: "#082D59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M312.655 124.223L397.21 118.791L386.647 140.239L302.28 144.683L312.655 124.223Z",
    fill: "#072142"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M312.914 126.513L393.015 121.636",
    stroke: "#53CD60",
    strokeWidth: 1.59883,
    strokeLinecap: "round",
    strokeDasharray: "2.31 2.31"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M310.676 132.222L390.777 127.345",
    stroke: "#53CD60",
    strokeWidth: 1.59883,
    strokeLinecap: "round",
    strokeDasharray: "2.31 2.31"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M306.574 136.937L386.675 132.06",
    stroke: "#53CD60",
    strokeWidth: 1.59883,
    strokeLinecap: "round",
    strokeDasharray: "2.31 2.31"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M304.744 141.834L384.845 136.957",
    stroke: "#53CD60",
    strokeWidth: 1.59883,
    strokeLinecap: "round",
    strokeDasharray: "2.31 2.31"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.623 169.821C107.458 168.54 106.104 167.781 104.925 168.309L16.3656 207.988C13.3069 209.359 11.4854 212.55 11.8607 215.88L19.393 282.723C19.7171 285.599 22.7659 287.311 25.3901 286.09L111.595 245.98C114.866 244.458 116.775 240.994 116.315 237.416L107.623 169.821Z",
    fill: "#19253D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.9434,
    y: 213.87,
    width: 31.9665,
    height: 32.2105,
    transform: "rotate(-24.0407 38.9434 213.87)",
    fill: "#19253D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6378 229.921C56.9299 229.795 57.1771 229.769 57.3794 229.844C57.5817 229.919 57.7408 230.09 57.8567 230.358C57.9187 230.501 57.9383 230.642 57.9158 230.782C57.8919 230.919 57.8247 231.047 57.7142 231.168C57.6023 231.285 57.446 231.387 57.2451 231.474L57.1745 231.26C57.2688 231.22 57.3827 231.187 57.5163 231.161C57.6485 231.133 57.7854 231.128 57.927 231.146C58.0702 231.16 58.2041 231.21 58.3285 231.297C58.4546 231.38 58.5572 231.512 58.6363 231.695C58.7232 231.896 58.7609 232.075 58.7493 232.231C58.7407 232.387 58.6984 232.523 58.6222 232.639C58.546 232.755 58.453 232.853 58.3432 232.933C58.232 233.01 58.1201 233.073 58.0076 233.122L56.8712 233.614C56.7921 233.648 56.714 233.651 56.6368 233.623C56.5614 233.591 56.5065 233.535 56.4723 233.456L55.33 230.818C55.2957 230.739 55.2933 230.662 55.3226 230.588C55.3536 230.51 55.4087 230.453 55.4878 230.419L56.6378 229.921ZM56.7889 230.495L55.9766 230.847L56.0043 230.748L56.362 231.574L56.2894 231.557L57.1109 231.201C57.1991 231.163 57.2657 231.1 57.3107 231.012C57.3556 230.924 57.3544 230.825 57.3069 230.715C57.2503 230.584 57.176 230.505 57.084 230.476C56.9938 230.443 56.8954 230.449 56.7889 230.495ZM57.3669 231.73L56.5363 232.09L56.5616 232.035L56.9786 232.998L56.9132 232.972L57.7803 232.597C57.9203 232.536 58.0155 232.452 58.066 232.343C58.1152 232.231 58.1075 232.101 58.043 231.952C57.9837 231.815 57.9135 231.728 57.8324 231.691C57.7513 231.654 57.6694 231.644 57.5867 231.662C57.5041 231.68 57.4308 231.702 57.3669 231.73Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9328 231.957C59.967 232.036 59.9702 232.115 59.9422 232.192C59.9128 232.266 59.8586 232.32 59.7795 232.354C59.7004 232.389 59.6238 232.391 59.5497 232.362C59.4743 232.329 59.4194 232.274 59.3851 232.194L58.5689 230.31C58.5347 230.231 58.5322 230.154 58.5615 230.08C58.5895 230.003 58.6431 229.947 58.7222 229.913C58.8013 229.878 58.8786 229.878 58.954 229.91C59.0281 229.939 59.0823 229.993 59.1166 230.073L59.9328 231.957ZM58.5892 229.618C58.4857 229.663 58.4055 229.678 58.3484 229.663C58.2913 229.648 58.2443 229.598 58.2074 229.512L58.1699 229.426C58.1317 229.337 58.1288 229.268 58.1612 229.218C58.1954 229.164 58.2612 229.115 58.3586 229.073C58.465 229.027 58.5468 229.011 58.6039 229.026C58.661 229.041 58.708 229.092 58.7449 229.177L58.7824 229.263C58.8206 229.352 58.8242 229.422 58.793 229.476C58.7606 229.526 58.6926 229.573 58.5892 229.618Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.955 230.816C62.028 230.784 62.0994 230.782 62.1691 230.81C62.2376 230.835 62.2876 230.883 62.3192 230.956C62.3495 231.026 62.3509 231.096 62.3233 231.166C62.2957 231.236 62.2454 231.286 62.1724 231.318L60.7029 231.954C60.6268 231.987 60.5541 231.986 60.4848 231.951C60.4154 231.916 60.3704 231.871 60.3497 231.815C60.333 231.768 60.322 231.726 60.3166 231.688C60.3099 231.648 60.3149 231.597 60.3317 231.535L60.8317 229.574L60.8502 229.642L59.9238 230.043C59.8508 230.074 59.7794 230.076 59.7096 230.049C59.6399 230.021 59.5892 229.971 59.5575 229.898C59.5272 229.828 59.5265 229.76 59.5555 229.693C59.5831 229.623 59.6334 229.572 59.7064 229.541L61.112 228.932C61.182 228.902 61.2525 228.902 61.3236 228.933C61.3947 228.963 61.4443 229.019 61.4724 229.101C61.4826 229.133 61.4897 229.166 61.4937 229.2C61.5008 229.233 61.4968 229.278 61.4818 229.335L60.9902 231.266L60.9784 231.239L61.955 230.816Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1196 228.145C65.2184 228.373 65.2726 228.603 65.2822 228.833C65.2918 229.064 65.2595 229.286 65.1855 229.498C65.1131 229.707 64.9995 229.895 64.8448 230.063C64.693 230.23 64.5046 230.362 64.2794 230.46C64.0543 230.557 63.829 230.604 63.6034 230.601C63.3779 230.597 63.1629 230.551 62.9584 230.463C62.7556 230.37 62.5734 230.241 62.4117 230.076C62.25 229.912 62.1197 229.715 62.0209 229.487C61.9221 229.259 61.8679 229.029 61.8583 228.799C61.8487 228.568 61.8801 228.348 61.9525 228.14C62.0265 227.927 62.1394 227.737 62.2912 227.571C62.4429 227.404 62.6314 227.271 62.8565 227.174C63.0816 227.076 63.307 227.029 63.5325 227.033C63.7611 227.035 63.9767 227.083 64.1795 227.175C64.384 227.264 64.5671 227.391 64.7288 227.555C64.8905 227.72 65.0208 227.917 65.1196 228.145ZM64.5263 228.402C64.4381 228.198 64.3173 228.032 64.164 227.903C64.0094 227.771 63.8395 227.688 63.6543 227.652C63.4692 227.617 63.2823 227.64 63.0937 227.722C62.905 227.803 62.7603 227.924 62.6595 228.083C62.5586 228.242 62.5027 228.422 62.4917 228.622C62.4838 228.82 62.5246 229.023 62.6142 229.23C62.7024 229.434 62.8224 229.602 62.9739 229.735C63.1272 229.864 63.2964 229.946 63.4816 229.982C63.6668 230.017 63.8537 229.994 64.0423 229.912C64.2309 229.83 64.3756 229.71 64.4765 229.551C64.5773 229.391 64.6332 229.212 64.6442 229.012C64.6539 228.809 64.6146 228.606 64.5263 228.402Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3818 229.116C67.1688 229.209 66.9659 229.266 66.7731 229.288C66.5791 229.307 66.3754 229.283 66.1623 229.216C66.1083 229.2 66.0614 229.175 66.0216 229.142C65.9819 229.108 65.9528 229.07 65.9343 229.028C65.904 228.958 65.902 228.886 65.9283 228.814C65.9563 228.736 66.0083 228.681 66.0844 228.648C66.1422 228.623 66.2018 228.619 66.2633 228.636C66.4197 228.68 66.5648 228.702 66.6985 228.702C66.8351 228.701 66.9872 228.664 67.1545 228.591C67.2671 228.543 67.3633 228.481 67.4431 228.407C67.5216 228.33 67.5772 228.249 67.61 228.167C67.6415 228.081 67.6407 228 67.6078 227.924C67.5682 227.832 67.5073 227.767 67.4248 227.727C67.3424 227.686 67.2357 227.669 67.1047 227.675C66.9723 227.679 66.8142 227.706 66.6302 227.756C66.4554 227.803 66.2951 227.829 66.1492 227.835C66.0021 227.837 65.8695 227.818 65.7513 227.779C65.6349 227.736 65.5331 227.671 65.4457 227.586C65.357 227.498 65.2843 227.389 65.2276 227.258C65.142 227.06 65.1191 226.87 65.1588 226.686C65.2017 226.502 65.294 226.335 65.4358 226.187C65.5776 226.039 65.7535 225.919 65.9634 225.829C66.1611 225.743 66.3569 225.694 66.5506 225.683C66.746 225.667 66.9167 225.681 67.0627 225.726C67.1812 225.758 67.2602 225.82 67.2998 225.911C67.3288 225.978 67.3293 226.05 67.3012 226.127C67.2732 226.204 67.2242 226.258 67.1543 226.288C67.1086 226.308 67.0616 226.312 67.0133 226.301C66.9461 226.279 66.8636 226.268 66.7656 226.267C66.6664 226.263 66.5658 226.269 66.464 226.284C66.3609 226.296 66.2698 226.319 66.1907 226.353C66.0598 226.41 65.956 226.475 65.8793 226.548C65.8055 226.619 65.7583 226.694 65.7377 226.772C65.7171 226.849 65.7233 226.926 65.7562 227.002C65.7958 227.093 65.8546 227.158 65.9326 227.197C66.0124 227.231 66.1104 227.244 66.2267 227.237C66.3416 227.227 66.4749 227.206 66.6267 227.173C66.8238 227.127 67.0006 227.097 67.1573 227.084C67.317 227.069 67.4583 227.078 67.5812 227.111C67.7028 227.142 67.8101 227.202 67.9032 227.292C67.9949 227.378 68.0744 227.499 68.1416 227.655C68.2272 227.852 68.2462 228.046 68.1986 228.237C68.151 228.427 68.0539 228.599 67.9074 228.753C67.7639 228.906 67.5887 229.027 67.3818 229.116Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6973 212.891C54.3872 213.798 52.3664 217.173 53.163 220.54C53.6611 222.646 55.1455 224.26 57.0109 225.01L56.3921 222.395C55.7382 221.806 55.2506 221.019 55.0327 220.098C54.4804 217.764 55.8626 215.424 58.1401 214.762L57.6973 212.891Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0371 212.102L58.2326 212.766L58.9186 215.666L61.1776 225.214C62.184 224.923 63.0683 224.402 63.7867 223.724L63.4738 222.401L61.0371 212.102ZM62.4511 215.575L64.4316 215.107C64.9887 215.815 65.4044 216.654 65.6256 217.588C66.1146 219.655 65.5419 221.725 64.261 223.225L62.4511 215.575ZM59.3593 220.032L60.6174 225.349C59.5917 225.55 58.5709 225.492 57.6252 225.219L56.5548 220.695L59.3593 220.032Z",
    fill: "#27AE60"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M161.101 239.593C163.743 238.634 162.675 234.679 159.91 235.18L109.56 244.3L16.2716 287.676L67.4258 273.609L161.101 239.593Z",
    fill: "#082D59"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3905_13064",
    x: 102.84,
    y: 57.4147,
    width: 207.866,
    height: 201.797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.7986,
    result: "effect1_foregroundBlur_3905_13064"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3905_13064",
    x: 90.9479,
    y: 42.7032,
    width: 231.647,
    height: 231.648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.772159,
    result: "effect1_foregroundBlur_3905_13064"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3905_13064",
    x: 73.0541,
    y: 28.223,
    width: 269.025,
    height: 269.025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.193
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.6272
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3905_13064"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3905_13064",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3905_13064",
    x: 53.69,
    y: 0.859619,
    width: 305.981,
    height: 305.981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36.7663
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3905_13064"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3905_13064",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3905_13064",
    x: 154.093,
    y: 88.2606,
    width: 106.679,
    height: 138.747,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31065
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.0277
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.8 0 0 0 0 0.376471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3905_13064"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3905_13064",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicyNew);
export default __webpack_public_path__ + "static/media/privacy-policy-new.db95ffdecf9c4b272e84aeec98beac8b.svg";
export { ForwardRef as ReactComponent };